import "./Css/index.css";
import "./Css/containers.css";
import "./Css/global.css";
import "./Css/loader.css";
import "./Css/theme.css";
import "./Css/componenets.css";
import App from "./App";
import React from "react";
import ReactDOM from "react-dom/client";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
